import { useClaims, useHasPermission } from "../../auth/useClaims";

// Handoff §9.9 - a single combined "manage" permission (not the usual
// separate Create/Edit split) covers create/edit/delete alike.
//
// Opening the master screen accepts EITHER code (2026-09-09). Reading the
// catalog is no longer gated at all server-side - the pickers that have to
// choose from this master were being 403'd - so this hook exists only to decide
// whether to show the master SCREEN, and a Sales.ManageServiceTypes holder must
// never be kept off it for want of a separate view code.
export const useCanViewServiceTypes = () => {
  const { permissions } = useClaims();
  return permissions.includes("Sales.ViewServiceTypes") || permissions.includes("Sales.ManageServiceTypes");
};
export const useCanManageServiceTypes = () => useHasPermission("Sales.ManageServiceTypes");
